<template>
  <div id="product-add-by-amazon">
    <button-scroll-to-top></button-scroll-to-top>
    <no-multi-channel-service v-if="noEvidenceImage" />
    <div v-if="!noEvidenceImage">
      <div v-show="reachProductLimit">
        <div class="text-center">
          <h3 class="m-t-lg">出品可能数を超過しています。</h3>
          <br>
          <br><h3 class="m-b-none">[<router-link :to="{path: '/setting/service-info'}">設定</router-link>]より</h3>
          <br><h3 class="m-t-none">出品可能数を増やして下さい。</h3>
          <br>
          <h3><a @click.prevent="handleComback" class="text--underline m-r-lg" href="javascript:void(0)">戻る</a></h3>
        </div>
      </div>
      <div v-show="!reachProductLimit">
        <div class="box-search-keyword-get-lastest" style="justify-content: space-between;">
          <div class="flexbox">
            <get-latest-products-button
              :key="`products-add-by-amazon`"
              getFrom="add-by-amazon"
              @handleGetLatestProducts="handleGetLatestProducts()"
            />
            <div class="box-search-keyword">
              <div class="item">
                <div class="item-addon">
                  <input type="text" v-model.trim="search" class="form-control input-search-keyword" placeholder="ASIN, 商品名">
                  <span class="clear-keyword-search" @click.prevent="clearKeywordSearch()"><i class="fa fa-times"></i></span>
                </div>
              </div>
              <div class="item"><button type="button" class="btn btn-primary btn-search" @click="onHandleSearch()">検索</button></div>
            </div>
          </div>
          <div class="text-center flexbox box-plan-info">
            <div v-if="!isEmptyObj(currentPlan)" class="mr-r-10">
              残り出品可能数：<span>{{ remainingProduct }}</span>件
            </div>
            <router-link :to="{name: 'Setting', params: {tab: 'service-info'}}" class="btn btn-primary btn-additional-of-list">出品数追加</router-link>
          </div>
        </div>

        <div class="products-add-by-amazon-table">
          <add-by-amazon-table
            :url="targetUrl"
            :extraUrl="['Product/get-image-name', 'Product/get-identifiers']"
            :extraUrlMode="true"
            :columns="columns"
            :filters="filters"
            :needExtraData="true"
            :loadingTableMode="true"
            :isHideNoItem="true"
            :clientMode="true"
            :checkedItems="checkedItems"
            ref="productAddTable"
            @extraData="extraData = $event"
            @countData="countData = $event"
            @checkBoxAll="checkBoxAll"
          >
            <template slot="deleteCheckBox" slot-scope="props">
              <div>
                <input type="checkbox" :value="props.rowData.asin" v-model="checkedItems" @change="refreshCheckAll">
              </div>
            </template>
            <template slot="productName" slot-scope="props">
              <div class="flexbox justify-between flex-nowrap flex-content-start gap-10">
                <div>
                  <div class="flexbox flex-nowrap gap-10">
                    <loading-block class="product-image" :value="props.rowData.image" type="image">
                      <img :src="props.rowData.image" alt="" class="product-img group-table__product_img product-image">
                    </loading-block>
                    <div class="">
                      <loading-block :value="props.rowData.productName" type="string" :class="{ 'group-table__product_name': props.isGroupTable, 'product-name': true }">
                        <a
                          :href="'https://www.amazon.co.jp/gp/offer-listing/' + props.rowData.asin"
                          target="_blank"
                          class="text--underline product-name"
                          >
                          {{ props.rowData.productName }}
                        </a>
                      </loading-block>
                      <div class="product-asin">{{ props.rowData.asin }}</div>
                      <div class="flexbox flex-content-center">
                        <loading-block :value="props.rowData.amazonPrice" type="money" style="flex-grow: 2;">
                          <span class="">Amazon価格：¥</span><span class="text-price-number">{{formatAmount(props.rowData.amazonPrice)}}</span>
                        </loading-block>
                      </div>
                    </div>
                  </div>
                  <div v-if="props.rowData.mark && props.rowData.mark !== 'NULL'" class="alert alert-warning mark-warning product-mark-warning" role="alert">
                    <i class="text-warning fa fa-exclamation-triangle text-size-20 warning-icon mark-warning" aria-hidden="true"></i>
                    <span class="mark-warning" v-html="props.rowData.mark"></span>
                  </div>
                </div>
                <div class="flex justify-right flex-nowrap gap-10">
                  <div v-if="props.rowData.hasYamatoOffer" class="box-warehouse box-warehouse-yamato flexbox justify-right">
                    <div class="flex gap-10">
                      <warehouse-icon
                        :key="`yamato-icon-${props.rowData.asin}}`"
                        :iconImage="icons.salmonYamato"
                        :warehouseName="`ヤマト運輸倉庫`"
                        :iconClassName="`yamato-icon`"
                        :imageClassName="`yamato-image`"
                        style="width: 30%;"
                      />
                      <div class="flexbox justify-right">
                        <div class="flexbox flex-nowrap gap-5">
                          <span class="w-80 text-right">受取金額</span>
                          <span>¥</span>
                          <product-input-money
                            :key="'products-yamato-offerPrice-' + props.rowData.asin"
                            :ref="'products-yamato-offerPrice-' + props.rowData.asin"
                            :value="props.rowData.yamatoOfferPrice"
                            validation="required|moneyMin:1|numberLength:6"
                            :product="props.rowData"
                            :warehouseType="`yamato`"
                            :class="{ 'alert-warning-text': comparePrice(props.rowData.yamatoOfferPrice, props.rowData.amazonPrice) }"
                            :customStyle="{color: '#800000', 'font-size': '20px'}"
                            @input="yamatoCheckBulkUpdate"
                            class="product-input-money"
                          />
                        </div>
                        <div class="flexbox flex-nowrap gap-5">
                          <span class="w-80 text-right">予想出品金額</span>
                          <span>¥</span>
                          <span class="w-100 expected-amount">{{yamatoExpectedAmount(props.rowData.yamatoOfferPrice)}}</span>
                        </div>
                      </div>
                    </div>
                    <div class="flexbox pd-t-15">
                      <span class="w-70 text-right">保管サイズ</span>
                      <span class="w-60 text-right">送料見積</span>
                      <span style="width: 17px;"></span>
                      <span class="w-100"></span>
                    </div>
                    <div class="flexbox">
                      <span class="w-70 text-right">{{ props.rowData.yamatoSizeName || '-' }}</span>
                      <span class="w-60 text-right">
                        <yamato-shipping-fee :key="props.rowData.asin" :rowData="props.rowData" :customStyle="{'font-size': '12px'}" checkFrom="list" />
                      </span>
                      <span style="width: 17px;"></span>
                      <span class="w-100 text-right">
                        <span class="text-size-28 text-primary font-bold">{{ formatQuantity(props.rowData.yamatoInventoryQuantity) }}</span>
                        個
                        </span>
                    </div>
                  </div>
                  <div v-if="props.rowData.hasAcrossOffer" class="box-warehouse box-warehouse-across flexbox justify-right">
                    <div class="flex gap-10">
                      <warehouse-icon
                        :key="`across-icon-${props.rowData.asin}}`"
                        :iconImage="icons.salmonAcross"
                        :warehouseName="`ACROSS倉庫`"
                        :iconClassName="`across-icon`"
                        :imageClassName="`across-image`"
                        style="width: 30%;"
                      />
                      <div class="flexbox justify-right">
                        <div class="flexbox flex-nowrap gap-5">
                          <span class="w-80 text-right">受取金額</span>
                          <span>¥</span>
                          <product-input-money
                            :key="'products-across-offerPrice-' + props.rowData.asin"
                            :ref="'products-across-offerPrice-' + props.rowData.asin"
                            :value="props.rowData.acrossOfferPrice"
                            validation="required|moneyMin:1|numberLength:6"
                            :product="props.rowData"
                            :warehouseType="`across`"
                            :class="{ 'alert-warning-text': comparePrice(props.rowData.acrossOfferPrice, props.rowData.amazonPrice) }"
                            :customStyle="{color: '#800000', 'font-size': '20px'}"
                            @input="acrossCheckBulkUpdate"
                            class="product-input-money"
                          />
                        </div>
                        <div class="flexbox flex-nowrap gap-5">
                          <span class="w-80 text-right">予想出品金額</span>
                          <span>¥</span>
                          <span class="w-100 expected-amount">{{expectedAmount(props.rowData.acrossOfferPrice)}}</span>
                        </div>
                      </div>
                    </div>
                    <div class="flexbox pd-t-15">
                        <span class="w-70 text-right">保管サイズ</span>
                        <span class="w-60 text-right">送料見積</span>
                        <span style="width: 17px;"></span>
                        <span class="w-100"></span>
                    </div>
                    <div class="flexbox">
                      <span class="w-70 text-right">{{ props.rowData.acrossSizeName || '-' }}</span>
                      <span class="w-60 text-right">{{ props.rowData.acrossShippingFee ? '¥' + formatQuantity(props.rowData.acrossShippingFee) : '-' }}</span>
                      <span style="width: 17px;"></span>
                      <span class="w-100 text-right">
                        <span class="text-size-28 text-primary font-bold">{{ formatQuantity(props.rowData.acrossQuantity) }}</span>
                        個
                        </span>
                    </div>
                  </div>
                  <div class="box-warehouse flexbox justify-right">
                    <div class="flex gap-10">
                      <warehouse-icon
                        :key="`amazon-icon-${props.rowData.asin}}`"
                        :iconImage="icons.Amazon"
                        :warehouseName="`Amazon倉庫`"
                        :iconClassName="`amazon-icon`"
                        :imageClassName="`amazon-image`"
                        style="width: 30%;"
                      />
                      <div class="flexbox justify-right">
                        <div class="flexbox flex-nowrap gap-5">
                          <span class="w-80 text-right">受取金額</span>
                          <span>¥</span>
                          <product-input-money
                            :key="'products-amazon-offerPrice-' + props.rowData.asin"
                            :ref="'products-amazon-offerPrice-' + props.rowData.asin"
                            :value="props.rowData.offerPrice"
                            validation="required|moneyMin:1|numberLength:6"
                            :product="props.rowData"
                            :class="{ 'alert-warning-text': comparePrice(props.rowData.offerPrice, props.rowData.amazonPrice) }"
                            :customStyle="{color: '#800000', 'font-size': '20px'}"
                            @input="checkBulkUpdate"
                            class="product-input-money"
                            style="width: 100px;"
                          />
                        </div>
                        <div class="flexbox flex-nowrap gap-5">
                          <span class="w-80 text-right">予想出品金額</span>
                          <span>¥</span>
                          <span class="w-100 expected-amount">{{expectedAmount(props.rowData.offerPrice)}}</span>
                        </div>
                      </div>
                    </div>
                    <div class="flexbox pd-t-15">
                      <span class="w-80 text-right">送料見積</span>
                      <span style="width: 17px;"></span>
                      <span class="w-100"></span>
                    </div>
                    <div class="flexbox">
                      <span class="w-80 text-right">
                        <shipping-fee :key="props.rowData.asin" :rowData="props.rowData" :customStyle="{'font-size': '12px'}" checkFrom="list" />
                      </span>
                      <span style="width: 17px;"></span>
                      <span class="w-100 text-right">
                        <span class="text-size-28 text-primary font-bold">{{ formatQuantity(props.rowData.numberOfStock) }}</span>
                        個
                        </span>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <template slot="action" slot-scope="props">
              <button type="button" class="btn btn-warning" @click.prevent="addProduct(props.rowData)">追加</button>
            </template>
          </add-by-amazon-table>
        </div>
        <div v-if="checkedItems.length" class="box-add-amz-product-checked-all">
          <button type="button" class="btn btn-warning add-amz-product-checked-all" @click.prevent="addProducts()">選択した商品を追加</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InputMoney from '@/components/AmazonInputMoney'
import AddByAmazonTable from '@/components/AddByAmazonTable'
import LoadingBlock from '@/components/LoadingBlock'
import ShippingFee from '@/components/ShippingFee'
import YamatoShippingFee from '@/components/YamatoShippingFee'
import GetLatestProductsButton from '@/components/GetLatestProductsButton'
import ProductService from '@/services/productservice'
import PlanService from '@/services/planservice'
import Util from '@/common/utility'
import * as code from '@/common/code'
import { RomajiCheck } from '@/validation/custom-rules'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'
import ButtonScrollToTop from '@/components/ButtonScrollToTop'
import NoMultiChannelService from '@/components/NoMultiChannelService'
import { mapGetters } from 'vuex'
import ProductInputMoney from '@/view/productsNew/ProductInputMoney'
import WarehouseIcon from '@/view/productsNew/WarehouseIcon'
import WarehouseService from '@/services/warehouseservice'

export default {
  props: {
    hasRefreshAmazonTable: {
      type: Boolean,
      default: false
    },
    currentTab: {
      type: String,
      default: ''
    }
  },
  components: {
    InputMoney,
    LoadingBlock,
    ShippingFee,
    GetLatestProductsButton,
    ButtonScrollToTop,
    AddByAmazonTable,
    NoMultiChannelService,
    YamatoShippingFee,
    ProductInputMoney,
    WarehouseIcon
  },

  data () {
    return {
      error: null,
      loader: null,
      countData: null,
      extraData: null,
      resetValidator: false,
      columns: [
        {
          title: '',
          name: 'deleteCheckBox',
          label: '<input type="checkbox" id="amz-delete-checkbox-all">',
          field: 'deleteCheckBox',
          customCell: true,
          cellClass: 'text-center align-middle',
          headerClass: 'w-30',
          sortable: false,
          checkable: true,
          thClass: 'grouped-table-header',
          tdClass: 'align-middle',
          width: '30px'
        },
        {
          title: '商品情報',
          sortable: false,
          name: 'productName',
          label: '<div class="flexbox justify-between"><span>商品情報</span><span>倉庫毎の情報 ※各金額は税込金額とする</span></div>',
          field: 'productName',
          customCell: true,
          cellClass: 'text-left product-list-name',
          headerClass: 'grouped-table-header',
          thClass: 'grouped-table-header product-name',
          minWidth: '552px'
        },
        {
          title: '更新',
          name: 'action',
          label: '',
          field: 'action',
          customCell: true,
          cellClass: 'text-center update-button',
          headerClass: 'w-80',
          sortable: false,
          thClass: 'grouped-table-header',
          tdClass: 'text-center',
          width: '80px'
        }
      ],
      reachProductLimit: false,
      search: '',
      filters: {
        keyword: ''
      },
      checkAll: false,
      checkedItems: [],
      currentPlan: {},
      remainingProduct: null,
      isGetLatestProducts: false,
      icons: {
        'Amazon': '',
        'salmonYamato': '',
        'salmonAcross': ''
      }
    }
  },

  computed: {
    targetUrl () {
      let url = 'Product/available_no_refresh'
      let canGetLatestProducts = this.$store.state.user.user.canGetLatestProducts
      if (canGetLatestProducts === null || this.isGetLatestProducts) {
        url = 'Product/available'
      }
      return url
    },
    ...mapGetters({
      userInfo: 'getUser'
    }),
    noEvidenceImage () {
      return ['0', '9'].includes(this.userInfo.multiChannelSenderFlg)
    }
  },

  created () {
    this.loader = this.$loading.show()
    this.getPlanStatus()
    this.getWarehouseIcon()
  },
  watch: {
    $route (routeValue) {
      if (!this.noEvidenceImage) {
        // this.$refs.productAddTable.resetHeaderTabAddByAmazon()
        if (this.hasRefreshAmazonTable && routeValue.params.tab === 'add-by-amazon') {
          this.search = ''
          this.filters.keyword = this.search
          setTimeout(() => {
            this.$refs.productAddTable.reload(true)
            this.getPlanStatus()
            this.$emit('handleNotRefreshAmazonTable', false)
          }, 500)
        }

        if (routeValue.params.tab === 'add-by-amazon' && this.reachProductLimit) {
          this.reachProductLimit = false
        }
      }
    }
  },
  mounted () {
    this.$events.listen('done', (url) => {
      ((url === 'Product/available') || (url === 'Product/available_no_refresh')) && this.loader && this.loader.hide()
    })
    this.$events.listen('apiSuccess', (url) => {
      if ((url === 'Product/available' || url === 'Product/available_no_refresh') && this.resetValidator) {
        this.$validator.reset()
        this.resetValidator = false
      }
    })
    if (this.currentTab && this.currentTab === 'add-by-amazon') {
      let logParams = {
        name: eventCode.manage_products.add_by_amazon_tab.show,
        properties: {}
      }
      EventService.postTrackLog(logParams)
    }
  },

  methods: {
    async getWarehouseIcon () {
      let params = {
        type: 'all'
      }
      await WarehouseService.getWarehouseIcon(params)
        .then(response => {
          if (response.data) {
            this.icons = response.data
          }
        })
    },
    // Amazonの価格より50％以上高い時, 50％以上安い時警告
    comparePrice (offerPrice, amazonPrice) {
      var checkResult = false
      var inputPrice = Number.parseInt(offerPrice)
      var basePrice = Number.parseInt(amazonPrice)
      if (this.isNumber(inputPrice) && this.isNumber(basePrice) && basePrice > 0) {
        const halfPrice = basePrice * 0.5
        if (inputPrice <= halfPrice) {
          checkResult = true
        }
        const oneHalfPrice = basePrice * 1.5
        if (inputPrice >= oneHalfPrice) {
          checkResult = true
        }
        if ((inputPrice > halfPrice) && (inputPrice < oneHalfPrice)) {
          checkResult = false
        }
      }
      return checkResult
    },
    isNumber (numVal) {
      // チェック条件パターン
      var pattern = /^[-]?([1-9]\d*|0)(\.\d+)?$/
      // 数値チェック
      return pattern.test(numVal)
    },
    /*
     * Return img source from DB or noimg url
     *
     * @param {String} value Img src
     *
     * @return {String}
     */
    prepareImgSrc (value) {
      return value || `${process.env.NODE_DOMAIN}/static/dists/img/noimg.png`
    },
    /*
     * Call API to add product
     *
     * @param {Object} item Row's data
     *
     * @return void
     */
    validateItemOfferPrice (item) {
      let offerPrice = parseInt(item.offerPrice)
      if (!offerPrice || (offerPrice === 0) || (offerPrice.toString().length > 6)) {
        return false
      }

      if (item.hasYamatoOffer) {
        let yamatoOfferPrice = parseInt(item.yamatoOfferPrice)
        if (!yamatoOfferPrice || (yamatoOfferPrice === 0) || (yamatoOfferPrice.toString().length > 6)) {
          return false
        }
      }

      if (item.hasAcrossOffer) {
        let acrossOfferPrice = parseInt(item.acrossOfferPrice)
        if (!acrossOfferPrice || (acrossOfferPrice === 0) || (acrossOfferPrice.toString().length > 6)) {
          return false
        }
      }
      return true
    },
    async addProduct (item) {
      if (!this.validateItemOfferPrice(item) && (!item.ean || (item.ean.toString().length <= 50 && RomajiCheck.validate(item.ean)))) return false

      let params = {
        record: []
      }

      params.record.push({
        asin: item.asin,
        sku: item.sku,
        offerPrice: item.offerPrice,
        yamatoOfferPrice: item.yamatoOfferPrice,
        acrossOfferPrice: item.acrossOfferPrice,
        ean: item.ean && item.ean.toString().length > 0 ? item.ean : null
      })

      if (params.record.length) {
        let logParams = {
          name: eventCode.manage_products.add_by_amazon_tab.click_add_button,
          properties: {
            asin: item.asin
          }
        }
        EventService.postTrackLog(logParams)

        this.loader = this.$loading.show()
        await ProductService.addProducts(params)
          .then(response => {
            this.$refs.productAddTable.handleData(item, 'delete')
            this.checkedItems = this.checkedItems.filter(checkedItemAsin => checkedItemAsin !== item.asin)
            let addedAsins = [params.record[0].asin]
            let parentProductsCreateParams = {
              asin: addedAsins
            }
            this.loader && this.loader.hide()
            this.getPlanStatus()
            this.createParentProducts(parentProductsCreateParams)
          })
          .catch(error => {
            if (error === code.reachProductLimit) {
              this.reachProductLimit = true
            } else {
              this.$store.commit('toggleModal', {
                show: true,
                message: error
              })
            }
            this.loader && this.loader.hide()
            this.err = error
          })
      }
    },

    async addProducts () {
      if (!this.checkedItems.length) {
        return false
      }
      let params = {
        record: []
      }
      this.checkedItems.forEach((checkedItemAsin) => {
        let product = this.$refs.productAddTable.pageData.find((item) => {
          return item.asin === checkedItemAsin
        })

        if (product && this.validateItemOfferPrice(product) && (!product.ean || (product.ean.toString().length <= 50 && RomajiCheck.validate(product.ean)))) {
          params.record.push({
            asin: checkedItemAsin,
            sku: product.sku,
            offerPrice: product.offerPrice,
            yamatoOfferPrice: product.yamatoOfferPrice,
            acrossOfferPrice: product.acrossOfferPrice,
            ean: product.ean && product.ean.toString().length > 0 ? product.ean : null
          })
        }
      })
      if (params.record.length) {
        let logParams = {
          name: eventCode.manage_products.add_by_amazon_tab.click_add_all_button,
          properties: {
            asins: params.record.map(item => item.asin)
          }
        }
        EventService.postTrackLog(logParams)

        this.loader = this.$loading.show()
        await ProductService.addProducts(params)
          .then(response => {
            this.loader && this.loader.hide()
            let addedAsins = params.record.map(param => param.asin)
            this.$refs.productAddTable.handleData(addedAsins, 'deleteAll')
            let parentProductsCreateParams = {
              asin: addedAsins
            }
            this.getPlanStatus()
            this.createParentProducts(parentProductsCreateParams)
            this.checkAll = false
            this.checkedItems = []
          })
          .catch(error => {
            if (error === code.reachProductLimit) {
              this.reachProductLimit = true
            } else {
              this.$store.commit('toggleModal', {
                show: true,
                message: error
              })
            }
            this.loader && this.loader.hide()
            this.err = error
          })
      }
    },
    async createParentProducts (params) {
      this.loader = this.$loading.show()
      await ProductService.createParentProducts(params)
        .then(response => {
          this.loader && this.loader.hide()
          this.$emit('handleRefreshGroupTable', true)
        })
        .catch(err => {
          this.loader && this.loader.hide()
          this.error = err
        })
    },
    formatAmount (value) {
      return (value === null || typeof value === 'undefined' || value === 0) ? '-' : `${Util.formatMoney(value)}`
    },
    formatQuantity (value) {
      return (value === null || typeof value === 'undefined') ? '' : `${Util.formatMoney(value)}`
    },
    expectedAmount (offerPrice) {
      const coefficient = this.extraData && this.extraData.coefficient ? this.extraData.coefficient : 1.3
      const tmpOfferPrice = Math.round(offerPrice)
      if (offerPrice !== null && offerPrice > 0 && tmpOfferPrice.toString().length <= 6) {
        return this.formatAmount(offerPrice * coefficient)
      }
      return ' -'
    },
    yamatoExpectedAmount (offerPrice) {
      const coefficient = this.extraData && this.extraData.coefficient ? this.extraData.coefficient : 1.3
      const tmpOfferPrice = Math.round(offerPrice)
      if (offerPrice !== null && offerPrice > 0 && tmpOfferPrice.toString().length <= 6) {
        return this.formatAmount(offerPrice * coefficient)
      }
      return ' -'
    },
    /*
     * Custom sort for expected amount column
     *
     * @param {Array} data Table data
     * @param {String} order Order direction
     *
     * @return {String}
     */
    sortExpectedAmount (data, order) {
      if (!order) {
        return [...data]
      } else if (order === 'desc') {
        return [...data].sort((before, after) => before.offerPrice - after.offerPrice)
      }
      return [...data].sort((before, after) => after.offerPrice - before.offerPrice)
    },
    onHandleSearch () {
      this.checkAll = false
      this.checkedItems = []
      if ((this.filters.keyword === this.search)) {
        this.$refs.productAddTable.reload(false, true, true)
      } else {
        this.filters.keyword = this.search
      }
      let logParams = {
        name: eventCode.manage_products.add_by_amazon_tab.click_search_button,
        properties: {
          keyword: this.filters.keyword
        }
      }
      EventService.postTrackLog(logParams)
    },
    handleGetLatestProducts () {
      this.resetFilters()
      this.isGetLatestProducts = true
      setTimeout(() => {
        this.resetValidator = true
        this.$refs.productAddTable.reload(true)
        this.$emit('handleRefreshGroupTable', true)
      }, 1000)
    },
    async getPlanStatus () {
      let self = this
      let response = await PlanService.getPlanStatus()
      self.currentPlan = response.salmonPlan.currentPlan
      self.remainingProduct = response.salmonPlan.remainingProduct
      if (this.noEvidenceImage) {
        this.$events.fire('done', 'Product/available_no_refresh')
      }
    },
    isEmptyObj (obj) {
      return Util.isEmptyObj(obj)
    },
    refreshCheckAll () {
      const items = this.$refs.productAddTable.pageData
      if (this.checkedItems.length === items.length) {
        this.checkAll = true
      } else {
        this.checkAll = false
      }
    },
    checkBoxAll (value) {
      const items = this.$refs.productAddTable.pageData
      this.checkAll = value
      this.checkedItems = []
      var _self = this
      if (this.checkAll) {
        items.forEach(function (item) {
          _self.checkedItems.push(item.asin)
        })
      }
    },
    handleComback () {
      this.reachProductLimit = false
    },
    resetFilters () {
      this.search = ''
      this.filters.keyword = ''
    },
    clearKeywordSearch () {
      this.search = ''
    },
    checkBulkUpdate (data) {
      if (!this.$refs.productAddTable) return

      const targetItems = this.$refs.productAddTable.pageData
      let product = data.product
      let price = data.price

      targetItems.forEach(item => {
        if (item.asin === product.asin) {
          item.offerPrice = price
        }
      })
    },
    yamatoCheckBulkUpdate (data) {
      if (!this.$refs.productAddTable) return

      const targetItems = this.$refs.productAddTable.pageData
      let product = data.product
      let price = data.price

      targetItems.forEach(item => {
        if (item.asin === product.asin) {
          item.yamatoOfferPrice = price
        }
      })
    },
    acrossCheckBulkUpdate (data) {
      if (!this.$refs.productAddTable) return

      const targetItems = this.$refs.productAddTable.pageData
      let product = data.product
      let price = data.price

      targetItems.forEach(item => {
        if (item.asin === product.asin) {
          item.acrossOfferPrice = price
        }
      })
    }
  },
  beforeDestroy () {
    this.loader && this.loader.hide()
  }
}
</script>

<style scoped>
#product-add-by-amazon /deep/ .table > tbody > tr > td {
  vertical-align: top;
  padding-top: 8px;
}
.box-add-amz-product-checked-all {
  text-align: center;
  margin-top: 30px;
}
.box-add-amz-product-checked-all .btn-add-amz-product-checked-all {
  border-radius: 5px;
}
.box-warehouse {
  width: 260px;
  padding: 5px;
  border: 1px solid #ff9900;
  border-radius: 8px;
  background-image: linear-gradient(0deg, #eff1f2 50%, #fff 50%);
  font-size: 12px;
}
.box-warehouse-yamato {
  border: 1px solid #f6d131;
}
.box-warehouse-across {
  border: 1px solid #008CC6;
}
.product-input-money {
  width: 100px;
  height: 35px;
  color: #800000;
  font-weight: bold;
}
.text-price {
  color: #B12704;
}
.text-price-number {
  font-size: 20px;
  font-weight: bold;
}
.flex-nowrap {
  flex-wrap: nowrap;
}
.expected-amount {
  text-align: right;
  padding: 3px 15px;
}
.text-primary {
  color: #2e75b6;
}
@media (max-width: 1300px) {
  .box-search-keyword-get-lastest {
    display: block;
  }
  .box-plan-info {
    margin-top: 10px;
    justify-content: end;
  }
}
@media (max-width: 768px) {
  #product-add-by-amazon {
    padding: 15px;
  }
}
@media (max-width: 576px) {
  #product-add-by-amazon {
    padding: 10px 5px;
  }
  .box-plan-info {
    margin-top: 0px;
  }
  .box-search-keyword .input-search-keyword {
    width: 300px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/productsNew/ProductNewAdd.vue